import React, { useEffect, useState, useRef } from "react";
import Menu from "../../panel/Menu";
import {
  Box, Card, CardContent, Typography, IconButton, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField, Grid,
  Button, Stepper, Step, StepLabel, Paper, Tooltip, FormControl, InputLabel, MenuItem, Select,
  Stack,
  Divider,
  CardHeader,
  Avatar,
  CircularProgress
} from "@mui/material";
import { ArrowBack, ArrowForward, Bed, Person, Phone, Event, ArrowForwardIos, ArrowBackIosNew, Remove, Add, Delete } from "@mui/icons-material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { addDoc, collection, doc, getCountFromServer, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { db, storage } from "../../firebase";
import { addDays, format, differenceInDays, isWithinInterval, startOfDay, parseISO, eachDayOfInterval } from "date-fns";
import { motion, AnimatePresence } from "framer-motion";
import moment from "moment/moment";
import { getDownloadURL, ref, uploadString } from 'firebase/storage';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";


const PAGE_SIZE = 7; // Increased viewable days
const LEFT_COL_WIDTH = 160;
const COL_WIDTH = 156;
const ROW_HEIGHT = 40;

const COLORS = ["#3f51b5", "#009688", "#795548", "#673ab7", "#e91e63", "#ff9800"];
const steps = ['Room Details', 'Customer Details', 'Document Section', 'Payment Details'];
const today = new Date().toISOString().split('T')[0];

export default function Reserveroom() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });
  const navigate = useNavigate();
  const auth = getAuth();
  const [propertyId, setPropertyId] = useState(null);
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomNumbers, setRoomNumbers] = useState({});
  const [reservations, setReservations] = useState([]);
  const [paymodes, setpaymodes] = useState([]);
  const [dates, setDates] = useState([]);
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [bookingtypes, setbookingtypes] = useState([]);
  const [rooms, setrooms] = useState([]);
  const [plans, setplans] = useState([]);

  const [bookingrooms, setbookingrooms] = useState([]);

  const [companydetails, setcompanydetails] = useState(" ");

  const [activeStep, setActiveStep] = useState(0);
  const [checkindate, setcheckindate] = useState(moment().format('YYYY-MM-DD'));
  const [checkoutdate, setcheckoutdate] = useState(moment().add(1, 'days').format('YYYY-MM-DD'));
  const [noofdays, setnoofdays] = useState(1);
  const [checkintime, setcheckintime] = useState(moment().format('HH:mm A'));
  const [checkouttime, setcheckouttime] = useState('12:00 PM');
  const [adults, setadults] = useState(2);
  const [childs, setchilds] = useState(0);
  const [noofrooms, setnoofrooms] = useState(0);
  const [custname, setcustname] = useState(" ");
  const [mobile, setmobile] = useState(" ");
  const [email, setemail] = useState(" ");
  const [address, setaddress] = useState(" ");
  const [city, setcity] = useState(" ");
  const [state, setstate] = useState("Maharashtra");
  const [gender, setgender] = useState("Male");
  const [visitpurpose, setvisitpurpose] = useState(" ");
  const [gstname, setgstname] = useState(" ");
  const [gstno, setgstno] = useState(" ");
  const [bookingsource, setbookingsource] = useState(" ");
  const [documenttype, setdocumenttype] = useState(" ");
  const [idno, setidno] = useState(" ");

  const webcamRef1 = useRef(null);
  const webcamRef2 = useRef(null);
  const webcamRef3 = useRef(null);
  const webcamRef4 = useRef(null);

  const [visitorPhoto, setvisitorPhoto] = useState('');
  const [idFront, setidFront] = useState('');
  const [idBack, setidBack] = useState('');
  const [couplePhoto, setcouplePhoto] = useState('');

  const [visitorPhotoUrl, setvisitorPhotoUrl] = useState('');
  const [idFrontUrl, setidFrontUrl] = useState('');
  const [idBackUrl, setidBackUrl] = useState('');
  const [couplePhotoUrl, setcouplePhotoUrl] = useState('');
  const [bookingDate, setbookingDate] = useState(moment().format('YYYY-MM-DD'));

  const [paymode1, setpaymode1] = useState(" ");
  const [amount1, setamount1] = useState(0);
  const [paytime1, setpaytime1] = useState(" ");
  const [paymode2, setpaymode2] = useState(" ");
  const [amount2, setamount2] = useState(0);
  const [paytime2, setpaytime2] = useState(" ");
  const [rooamount, setrooamount] = useState(0);
  const [totalamount, settotalamount] = useState(0);
  const [advance, setadvance] = useState(0);
  const [remaining, setremaining] = useState(0);
  const [roundoff, setroundoff] = useState(0);
  const [note, setnote] = useState(" ");

  const [rtypeid, setrtypeid] = useState(" ");
  const [roomid, setroomid] = useState(" ");
  const [planid, setplanid] = useState(" ");
  const [amount, setamount] = useState(0);
  const [discountupto, setdiscountupto] = useState(0);
  const [discount, setdiscount] = useState(0);
  const [roomrate, setroomrate] = useState(0);

  const [uploadingVisitor, setUploadingVisitor] = useState(false);
  const [uploadingIdFront, setUploadingIdFront] = useState(false);
  const [uploadingIdBack, setUploadingIdBack] = useState(false);
  const [uploadingCouple, setUploadingCouple] = useState(false);

  const [reservationMap, setReservationMap] = useState({});


  useEffect(() => {
    const arr = [];
    for (let i = 0; i < 180; i++) arr.push(startOfDay(addDays(new Date(), i)));
    setDates(arr);
  }, []);

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const snap = await getDocs(collection(db, "authroles"));
      snap.forEach((d) => { if (d.id === user.uid) setPropertyId(d.data().propertyId); });
    });

  }, []);

  useEffect(() => {
    if (propertyId) { loadRooms(); loadReservations(); }
  }, [propertyId]);

  useEffect(() => {
    fetchData1()
  }, []);

  const loadRooms = async () => {
    // ROOM TYPES
    const roomsSnap = await getDocs(
      query(collection(db, "rooms"), where("propertyId", "==", propertyId))
    );

    setRoomTypes(
      roomsSnap.docs.map(d => ({
        id: d.id,
        ...d.data(),
      }))
    );

    // ROOM NUMBERS WITH DOCUMENT ID
    const infoSnap = await getDocs(
      query(collection(db, "roominfos"), where("propertyId", "==", propertyId))
    );

    const map = {};

    infoSnap.docs.forEach(d => {
      const { roomTypeId, roomNo } = d.data();

      if (!map[roomTypeId]) map[roomTypeId] = [];

      map[roomTypeId].push({
        id: d.id,        // ✅ document id
        roomNo: roomNo,  // ✅ room number
      });
    });

    setRoomNumbers(map);
  };

  const buildReservationMap = (reservations) => {
    const map = {};

    reservations.forEach(r => {
      const checkin = new Date(r.checkindate);
      const checkout = new Date(r.checkoutdate);

      r.rooms?.forEach(room => {
        eachDayOfInterval({
          start: checkin,
          end: new Date(checkout.getTime() - 86400000) // exclude checkout
        }).forEach(day => {
          const key = `${room.roomno}_${format(day, "yyyy-MM-dd")}`;
          map[key] = r;
        });
      });
    });

    return map;
  };

  const loadReservations = async () => {
    const q = query(
      collection(db, "reservations"),
      where("propertyId", "==", propertyId),
      where("status", "==", "Booked")
    );

    const snap = await getDocs(q);

    const data = snap.docs.map(d => ({
      id: d.id,
      ...d.data(),
    }));

    setReservations(data);
    setReservationMap(buildReservationMap(data)); // 🔥 FAST LOOKUP
  };


  const visibleDates = dates.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  const getReservationForCell = (roomNo, date) => {
    const key = `${roomNo}_${format(date, "yyyy-MM-dd")}`;
    return reservationMap[key] || null;
  };


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const captureVisitor = () => {
    const imageSrc = webcamRef1.current.getScreenshot();
    setvisitorPhoto(imageSrc);
  };

  const captureIdFront = () => {
    const imageSrc = webcamRef2.current.getScreenshot();
    setidFront(imageSrc);
  };

  const captureIdBack = () => {
    const imageSrc = webcamRef3.current.getScreenshot();
    setidBack(imageSrc);
  };

  const captureCouple = () => {
    const imageSrc = webcamRef4.current.getScreenshot();
    setcouplePhoto(imageSrc);
  };

  const handlemobile = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, '');
    if (value.length <= 10) {
      setmobile(value);
    }

  }

  const uploadToFirebase1 = async () => {
    if (!visitorPhoto) return;

    try {
      setUploadingVisitor(true);

      const storageRef = ref(storage, `bookings/${Date.now()}.jpg`);
      await uploadString(storageRef, visitorPhoto, 'data_url');
      const url = await getDownloadURL(storageRef);
      setvisitorPhotoUrl(url);
      Toast.fire({ icon: "success", title: "Visitor photo uploaded" });

    } catch (err) {
      Toast.fire({ icon: "error", title: "Upload failed" });
    } finally {
      setUploadingVisitor(false);
    }
  };


  const uploadToFirebase2 = async () => {
    if (idFront) {
      try {
        setUploadingIdFront(true);
        const storageRef = ref(storage, `bookings/${Date.now()}.jpg`);
        await uploadString(storageRef, idFront, 'data_url');
        const downloadURL = await getDownloadURL(storageRef);
        setidFrontUrl(downloadURL)
        Toast.fire({ icon: "success", title: 'ID Front Successfully Uploaded' });
      } catch (error) {
        Toast.fire({ icon: "error", title: 'Error in ID Front Uploading!!' });
      }
      finally {
        setUploadingVisitor(false);
      }
    }
  };

  const uploadToFirebase3 = async () => {
    if (idBack) {
      try {
        setUploadingIdBack(true)
        const storageRef = ref(storage, `bookings/${Date.now()}.jpg`);
        await uploadString(storageRef, idBack, 'data_url');
        const downloadURL = await getDownloadURL(storageRef);
        setidBackUrl(downloadURL)
        Toast.fire({ icon: "success", title: 'ID Back Successfully Uploaded' });
      } catch (error) {
        Toast.fire({ icon: "error", title: 'Error in ID Back Uploading!!' });
      }
      finally {
        setUploadingIdBack(false)
      }

    }
  };

  const uploadToFirebase4 = async () => {
    if (couplePhoto) {
      try {
        setUploadingCouple(true)
        const storageRef = ref(storage, `bookings/${Date.now()}.jpg`);
        await uploadString(storageRef, couplePhoto, 'data_url');
        const downloadURL = await getDownloadURL(storageRef);
        setcouplePhotoUrl(downloadURL)
        Toast.fire({ icon: "success", title: 'Couple Photo Successfully Uploaded' });
      } catch (error) {
        Toast.fire({ icon: "error", title: 'Error in Couple Photo Uploading!!' });
      }
      finally {
        setUploadingCouple(false)
      }

    }
  };

  const fetchData1 = async () => {
    try {

      const q = query(collection(db, 'rooms'))
      onSnapshot(q, (querySnapshot) => {
        setRoomTypes(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      const q1 = query(collection(db, 'paymentmodes'), orderBy('createdAt', 'asc'))
      onSnapshot(q1, (querySnapshot) => {
        setpaymode1(querySnapshot.docs[0].id)
        setpaymode2(querySnapshot.docs[0].id)
        setpaymodes(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      const q2 = query(collection(db, 'bookingtypes'), orderBy('createdAt', 'asc'))
      onSnapshot(q2, (querySnapshot) => {
        setbookingtypes(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message
      });
    }
  }

  const handleDate1Change = (event) => {
    if (event.target.value < today || event.target.value > today) {
      setcheckindate(moment().format('YYYY-MM-DD'));
      handleDateChange(moment().format('YYYY-MM-DD'), checkoutdate);
    } else {
      setcheckindate(event.target.value);
      handleDateChange(event.target.value, checkoutdate);
    }
  };

  const handleDate2Change = (event) => {
    if (event.target.value < today) {
      setcheckoutdate(moment().add(1, 'days').format('YYYY-MM-DD'));
      handleDateChange(checkindate, moment().add(1, 'days').format('YYYY-MM-DD'));
    } else {
      setcheckoutdate(event.target.value);
      handleDateChange(checkindate, event.target.value);
    }

  };

  const handleDateChange = (date1, date2) => {
    if (date1 && date2) {
      const momentDate1 = moment(date1);
      const momentDate2 = moment(date2);
      const diffInDays = momentDate2.diff(momentDate1, 'days');
      if (diffInDays === 0) {
        setnoofdays(1);
        calFinalTotal(1, rooamount);
      } else {
        setnoofdays(diffInDays);
        calFinalTotal(diffInDays, rooamount);
      }
    }
  };

  const calFinalTotal = (days, roomamountxx) => {
    let total = parseFloat(days) * parseFloat(roomamountxx)
    let roundoff = total.toFixed(2) - total.toFixed(0);
    setroundoff(roundoff.toFixed(2));
    settotalamount(total.toFixed(0));
    setremaining(total.toFixed(0));
  }


  const handleroomtypeChange = (value) => {
    setrtypeid(value);
    setamount(0);
    setroomrate(0);
    setdiscount(0);
    setdiscountupto(0);

    const q = query(collection(db, 'roominfos'), where('roomTypeId', '==', value))
    onSnapshot(q, (querySnapshot) => {
      setrooms(querySnapshot.docs.map(doc => ({
        id: doc.id,
        data: doc.data()
      })));
    });

    const q1 = query(collection(db, 'roomrates'), where('roomId', '==', value))
    onSnapshot(q1, (querySnapshot) => {
      setplans(querySnapshot.docs.map(doc => ({
        id: doc.id,
        data: doc.data()
      })));
    });
  }

  const handleplanChange = async (planDocId) => {
    setplanid(planDocId);

    try {
      const docRef = doc(db, "roomrates", planDocId);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        const data = snap.data();

        const roomRate = Number(data.rate || 0);

        setamount(roomRate.toFixed(2));
        setroomrate(roomRate.toFixed(2));
        setdiscount(0);
        setdiscountupto(data.discount || 0);

      } else {
        console.log("No rate document found");
        setamount(0);
        setroomrate(0);
      }

    } catch (error) {
      console.error("Error fetching room rate:", error);
    }
  };
  const caltotal = (value) => {
    const discount = Number(value) || 0;
    const baseAmount = Number(amount) || 0;

    setdiscount(discount);

    if (discount > 0 && baseAmount > 0) {
      const discountAmount = (baseAmount * discount) / 100;
      const finalAmount = baseAmount - discountAmount;

      setroomrate(finalAmount.toFixed(2));
    } else {
      setroomrate(baseAmount.toFixed(2));
    }
  };


  const handleRoomArray = () => {
    if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
      Toast.fire({ icon: "error", title: "All fields are required" });
      return;
    }

    try {


      const matchedRoom = rooms.find(r => r.id === roomid);

      const roomno = matchedRoom?.data?.roomNo || "";
      const roomtypename = matchedRoom?.data?.roomTypeName || "";
      const rtypeid = matchedRoom?.data?.roomTypeId || "";

      // 🔹 Match plan
      const matchedPlan = plans.find(p => p.id === planid);
      const planname = matchedPlan?.data?.planName || "";


      // 🔹 Prepare new booking item
      const newItem = {
        roomid,
        roomno,
        rtypeid,
        roomtypename,
        planid,
        planname,
        amount: Number(amount).toFixed(2),
        discount: Number(discount || 0),
        roomrate: Number(roomrate).toFixed(2),
        // username,
      };

      // 🔹 Update booking rooms correctly
      const updatedRooms = [...bookingrooms, newItem];
      setbookingrooms(updatedRooms);

      // 🔹 Reset form fields
      setrtypeid("");
      setroomid("");
      setplanid("");
      setamount("");
      setdiscount("");
      setdiscountupto(0);
      setroomrate("");

      // 🔹 Rooms count
      setnoofrooms(updatedRooms.length);

      // 🔹 Calculate total room amount
      const totalRoomAmount = updatedRooms.reduce(
        (sum, r) => sum + Number(r.roomrate || 0),
        0
      );

      setrooamount(totalRoomAmount.toFixed(2));

      // 🔹 Final bill calculation
      calFinalTotal(noofdays, totalRoomAmount);

    } catch (error) {
      console.error("Error adding room:", error);
      Toast.fire({ icon: "error", title: "Something went wrong" });
    }
  };


  const handleamount1 = (e) => {
    let value = e.target.value;
    let advance = parseFloat(value) + parseFloat(amount2);
    if (parseFloat(advance) > parseFloat(totalamount)) {
      Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
      setadvance(0);
      setamount1(0)
      let rem = parseFloat(totalamount) - parseFloat(amount2);
      setremaining(rem.toFixed(2))
      return;
    }
    setamount1(parseFloat(value, 10))
    setadvance(advance);
    let rem = parseFloat(totalamount) - parseFloat(advance);
    setremaining(rem.toFixed(2))

  }

  const handleamount2 = (e) => {
    let value = e.target.value;
    let advance = parseFloat(amount1) + parseFloat(value);
    if (parseFloat(advance) > parseFloat(totalamount)) {
      Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
      setadvance(0);
      setamount2(0)
      let rem = parseFloat(totalamount) - parseFloat(amount1);
      setremaining(rem.toFixed(2))
      return;
    }

    setamount2(parseFloat(value, 10))
    setadvance(advance);
    let rem = parseFloat(totalamount) - parseFloat(advance);
    setremaining(rem.toFixed(2))
  }


  const removeItem = (itemToRemove) => {
    if (!window.confirm("Are you sure you want to remove this room?")) return;

    const updatedItems = bookingrooms.filter(
      (item) => item !== itemToRemove
    );

    setbookingrooms(updatedItems);

    const totalRoomAmount = updatedItems.reduce(
      (sum, item) => sum + Number(item.roomrate || 0),
      0
    );

    setrooamount(totalRoomAmount.toFixed(2));
    calFinalTotal(noofdays, totalRoomAmount);
  };

  const safe = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v !== undefined)
    );



  const checkoutReservation = async () => {
    try {

      if (!checkindate || !checkoutdate || !noofdays) {
        Toast.fire({ icon: "error", title: "Select check-in & check-out dates" });
        return;
      }

      if (bookingrooms.length === 0) {
        Toast.fire({ icon: "error", title: "Please select at least one room" });
        return;
      }

      if (!custname || !mobile || !address || !city) {
        Toast.fire({ icon: "error", title: "Fill required customer details" });
        return;
      }

      if (Number(advance) > 0 && (!paymode1 || !amount1)) {
        Toast.fire({ icon: "error", title: "Fill payment details" });
        return;
      }

      setIsLoading(true);

      /* =======================
         CUSTOMER
      ======================= */

      const customerData = {
        custname,
        mobile,
        email,
        address,
        city,
        state,
        gender,
        gstname,
        gstno,
        documenttype,
        idno,
        propertyId,
        uid: auth.currentUser?.uid,
        createdAt: Timestamp.now(),
      };

      const customerRef = await addDoc(collection(db, "customers"), customerData);

      /* =======================
         BOOKING
      ======================= */

      const q = query(
        collection(db, "reservations"),
        where("propertyId", "==", propertyId) // your propertyId variable
      );

      const bookingCountSnap = await getCountFromServer(q);
      const invoiceNo = bookingCountSnap.data().count + 1;

      const bookingPayload = safe({
        customerId: customerRef.id,
        invoiceno: invoiceNo,
        customers: customerData,
        rooms: bookingrooms,
        services: [],
        checkindate,
        checkoutdate,
        noofdays,
        checkintime,
        checkouttime,
        adults,
        childs,
        noofrooms: bookingrooms.length,
        visitpurpose,
        bookingsource,
        visitorPhotoUrl,
        idFrontUrl,
        idBackUrl,
        couplePhotoUrl,
        rooamount: Number(rooamount),
        roundoff: Number(roundoff),
        totalamount: Number(totalamount),
        advance: Number(advance),
        remaining: Number(remaining),
        note,
        bookingDate,
        type: "GST",
        status: "Booked",
        approval1: "No",
        approval2: "No",
        approval3: "No",
        approval4: "No",
        damageamount: 0,
        propertyId,
        uid: auth.currentUser.uid,
        createdAt: Timestamp.now(),
      });


      // console.log(bookingPayload);

      const bookingRef = await addDoc(collection(db, "reservations"), bookingPayload);

      /* =======================
         CHECK-IN DETAILS
      ======================= */


      for (let day = 0; day < noofdays; day++) {
        const inDate = moment(checkindate).add(day, "days").format("YYYY-MM-DD");
        const outDate = moment(checkindate).add(day + 1, "days").format("YYYY-MM-DD");

        for (const room of bookingrooms) {
          await addDoc(
            collection(db, "checkindetails"),
            safe({
              bookingid: bookingRef.id,
              customerId: customerRef.id,
              checkindate: inDate,
              checkoutdate: outDate,
              propertyId,
              roomid: room.roomid || "",
              roomtypeid: room.rtypeid || "",
              planid: room.planid || "",

              roomname: room.roomno || "",
              planname: room.plananme || "",   // ✅ FIX
              roomtype: room.roomtypename || "",

              status: "Booked",
              uid: auth.currentUser.uid,
              createdAt: Timestamp.now(),
            })
          );
        }
      }

      /* =======================
         PAYMENT HISTORY
      ======================= */

      if (Number(advance) > 0) {
        for (let i = 0; i < noofdays; i++) {
          await addDoc(collection(db, "payhistory"), {
            bookingid: bookingRef.id,
            customerId: customerRef.id,
            paymode1,
            amount1: Number(amount1) / noofdays,
            paytime1,
            paymode2,
            amount2: Number(amount2 || 0) / noofdays,
            paytime2,
            type: "Booking",
            paymenttype: "B",
            status: "Working",
            propertyId,
            uid: auth.currentUser?.uid,
            note,
            createdAt: Timestamp.fromDate(
              new Date(new Date().setDate(new Date().getDate() + i))
            ),
          });
        }
      }

      /* =======================
         UPDATE ROOMS STATUS
      ======================= */

      for (const room of bookingrooms) {
        await updateDoc(doc(db, "roominfos", room.roomid), {
          status: "Booked",
        });
      }

      /* =======================
         WHATSAPP (OPTIONAL)
      ======================= */

      const roomNames = bookingrooms.map(r => r.roomno).join(", ");
      const whatsappSnap = await getDocs(collection(db, "whatsapp"));

      if (!whatsappSnap.empty) {
        const w = whatsappSnap.docs[0].data();
        if (w.status === "ON") {
          sendWhatsAppMessage(
            custname,
            mobile,
            checkindate,
            checkoutdate,
            roomNames,
            totalamount,

          );
        }
      }

      /* =======================
         SUCCESS + RESET
      ======================= */

      Toast.fire({ icon: "success", title: "Reservation successfully completed" });

      setrooms([]); setplans([]); setbookingrooms([]); setActiveStep(0); setcheckindate(moment().format('YYYY-MM-DD'));
      setcheckoutdate(moment().add(1, 'days').format('YYYY-MM-DD')); setnoofdays(1); setcheckintime(moment().format('HH:mm A')); setcheckouttime('12:00 PM'); setadults(0);
      setchilds(0); setnoofrooms(0); setcustname(""); setmobile(""); setemail(""); setaddress(""); setcity(""); setstate(" "); setgender("Male");
      setvisitpurpose("Darshan"); setgstname(""); setgstno(""); setbookingsource("Walking"); setdocumenttype(""); setidno("");
      setvisitorPhoto(''); setidFront(''); setidBack(''); setcouplePhoto(''); setvisitorPhotoUrl(''); setidFrontUrl(''); setidBackUrl('');
      setcouplePhotoUrl(''); setpaymode1(""); setamount1(0); setpaytime1(""); setpaymode2(""); setamount2(0); setpaytime2(""); setrooamount(0);
      setadvance(0); setremaining(0); setnote(""); setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscountupto(0); setdiscount("");
      setroomrate("");
      loadReservations();

    } catch (error) {
      console.error(error);
      Toast.fire({
        icon: "error",
        title: "Reservation failed",
        text: error.message,
      });
    } finally {
      setIsLoading(false);
      loadReservations();
      setOpen(false)
    }
  };



  const handleamount = (e) => {
    setamount(e.target.value);
    setdiscount(0);
    setroomrate(e.target.value);
  }


  const sendWhatsAppMessage = async (custname, mobile, checkindate, checkoutdate, roomNames, totalamount) => {
    const wabaid = "591801274016500";
    const accesstoken = "EAAIYwoDRSHsBO6o4NeCQr0f1v9PrWvvI31boSykl9sGxFX4xZBzznLazzVm9LbaqNrBYSZAjccUUwjBohCovlp5l5RwESrnk3fkZCzLjNRVAbptz591adwdjQyZBx3FcMnIfAzz1oZBO1QxldkLzgOrR77KuDxfSz3vCFSZAy2Tz0s5RFmkUN5DbljSdn7N5qI6AZDZD";

    // Payload to send message
    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: '91' + mobile, // Customer's phone number with country code
      type: 'template',
      template: {
        name: 'checkin_confirmation', // Replace with the actual approved template name
        language: {
          code: 'en', // Language code used in the template
        },
        components: [
          {
            type: 'body',
            parameters: [
              { type: 'text', text: custname }, // Customer Name
              { type: 'text', text: roomNames }, // Room Number
              { type: 'text', text: '₹' + totalamount }, // Room Amount
              { type: 'text', text: moment(checkindate).format('DD-MM-YYYY') + ' 02:00 PM' }, // Check-in Time
              { type: 'text', text: moment(checkoutdate).format('DD-MM-YYYY') + ' 12:00 PM' }, // Check-in Time
            ],
          },
        ],
      },
    };

    // Sending the message
    try {
      const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accesstoken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        await addDoc(collection(db, 'whatsapphistory'), {
          custname: custname,
          type: 'Checkin',
          mobile: mobile,
          createdAt: Timestamp.now(),
          propertyId
        });

      } else {
        alert(`❌ Error: ${data.error.message}`);
        console.error('API Error:', data);
      }
    } catch (error) {
      console.error('Fetch Error:', error);
      alert('❌ Failed to send the message.');
    }
  };

  const handleClose = () => {
    // 1. Reset the stepper to the first step
    setActiveStep(0);

    // 2. Close the modal (this depends on the state variable controlling your modal's visibility)
    setOpen(false);

    // 3. Optional: Clear the form data
    // setForm(initialFormState);
  };

  const InfoRow = ({ label, value, highlight }) => (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography
        fontWeight={highlight ? 700 : 500}
        color={highlight ? "primary" : "text.primary"}
      >
        {value}
      </Typography>
    </Box>
  );

  const getRoomTypeData = (rt) => {
    handleroomtypeChange(rt.roomType.id);
    setroomid(rt.roomInfoId);

  }

  return (
    <Box display="flex" minHeight="100vh" bgcolor="#F0F2F5">
      <Menu />
      <Box className="content-wrapper" flex={1} p={2} component={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Box>
            <Typography variant="h5" fontWeight={800} color="primary">PMS Calendar</Typography>
          </Box>
          <Paper elevation={0} sx={{ borderRadius: 3, display: 'flex', gap: 1, border: '1px solid #ddd' }}>
            <IconButton onClick={() => setPage(Math.max(0, page - 1))}><ArrowBack /></IconButton>
            <Box display="flex" alignItems="center" px={2} fontWeight={600}>
              {format(visibleDates[0] || new Date(), "dd MMM")} - {format(visibleDates[PAGE_SIZE - 1] || new Date(), "dd MMM yyyy")}
            </Box>
            <IconButton onClick={() => setPage(page + 1)}><ArrowForward /></IconButton>
          </Paper>
        </Box>

        <Card sx={{ borderRadius: 2, boxShadow: "0 8px 32px rgba(0,0,0,0.08)", overflow: 'hidden' }}>
          <Box sx={{ overflowX: "auto", position: 'relative' }}>
            {/* GRID HEADER */}
            <Box display="flex" bgcolor="#fff">
              <Box minWidth={LEFT_COL_WIDTH} sx={{ p: 2, borderRight: "1px solid #eee", borderBottom: "2px solid #3f51b5", fontWeight: 800, color: '#3f51b5' }}>
                ROOM DETAILS
              </Box>
              {visibleDates.map((d) => (
                <Box key={d.toString()} width={COL_WIDTH} sx={{ p: 1, textAlign: "center", borderRight: "1px solid #eee", borderBottom: "2px solid #3f51b5", bgcolor: [0, 6].includes(d.getDay()) ? '#f9faff' : '#fff' }}>
                  <Typography variant="caption" fontWeight={700} color="textSecondary">{format(d, "EEE").toUpperCase()}</Typography>
                  <Typography variant="h6" fontWeight={800}>{format(d, "dd")}</Typography>
                </Box>
              ))}
            </Box>

            {/* GRID BODY */}
            {roomTypes.map((rt) =>
              (roomNumbers[rt.id] || []).map((room) => (
                <Box
                  key={`${rt.id}-${room.id}`}
                  display="flex"
                  sx={{ position: "relative", borderBottom: "1px solid #eee" }}
                >
                  {/* LEFT ROOM COLUMN */}
                  <Box
                    minWidth={LEFT_COL_WIDTH}
                    sx={{
                      p: 1,
                      borderRight: "1px solid #eee",
                      bgcolor: "#fff",
                      zIndex: 2,
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight={800}>
                      Room {room.roomNo}
                    </Typography>

                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <Bed fontSize="inherit" /> {rt.roomTypeName}
                    </Typography>
                  </Box>

                  {/* DATE CELLS */}
                  {visibleDates.map((d) => {
                    const res = getReservationForCell(room.roomNo, d);
                    const isCheckIn =
                      res && res.checkindate === format(d, "yyyy-MM-dd");

                    return (
                      <Box
                        key={d.toISOString()}
                        width={COL_WIDTH}
                        height={ROW_HEIGHT}
                        sx={{
                          borderRight: "1px solid #eee",
                          position: "relative",
                          cursor: res ? "default" : "cell",
                          "&:hover": {
                            bgcolor: res ? "transparent" : "#f0f7ff",
                          },
                        }}
                        onClick={() => {
                          if (res) return;

                          setSelected({
                            roomType: rt,
                            roomNumber: room.roomNo,
                            roomInfoId: room.id, // ✅ IMPORTANT
                          });

                          getRoomTypeData({
                            roomType: rt,
                            roomNumber: room.roomNo,
                            roomInfoId: room.id, // ✅ PASSING HERE
                          });

                          setcheckindate(format(d, "yyyy-MM-dd"));
                          setcheckoutdate(
                            format(addDays(d, 1), "yyyy-MM-dd")
                          );

                          setOpen(true);
                        }}
                      >
                        {/* BOOKING BAR */}
                        <AnimatePresence>
                          {isCheckIn && (
                            <motion.div
                              initial={{ scale: 0.9, opacity: 0 }}
                              animate={{ scale: 1, opacity: 1 }}
                              onClick={(e) => {
                                e.stopPropagation(); // ⛔ prevent cell click
                                navigate(`/reservation-details/${res.id}`);
                              }}
                              style={{
                                position: "absolute",
                                top: 8,
                                left: 4,
                                height: ROW_HEIGHT - 6,
                                width: `calc(${differenceInDays(
                                  parseISO(res.checkoutdate),
                                  parseISO(res.checkindate)
                                )} * ${COL_WIDTH}px - 8px)`,
                                backgroundColor:
                                  COLORS[res.id.charCodeAt(0) % COLORS.length],
                                color: "white",
                                borderRadius: "8px",
                                zIndex: 10,
                                padding: "10px 20px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                cursor: "pointer", // 👈 show clickable
                              }}
                            >

                              {/* Customer Name */}
                              <Typography
                                variant="caption"
                                fontWeight={800}
                                sx={{
                                  textShadow: "1px 1px 2px rgba(0,0,0,0.25)",
                                  lineHeight: 1.2,
                                }}
                              >
                                {res.customers?.custname?.toUpperCase()}
                              </Typography>

                              {/* Amount */}
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: "11px",
                                  opacity: 0.9,
                                  lineHeight: 1.1,
                                }}
                              >
                                ₹ {Number(res.totalamount).toLocaleString("en-IN")} /-
                              </Typography>
                            </motion.div>
                          )}
                        </AnimatePresence>

                      </Box>
                    );
                  })}
                </Box>
              ))
            )}

          </Box>
        </Card>
      </Box>

      {/* ENHANCED BOOKING DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xl">
        <DialogTitle sx={{ fontWeight: 800, bgcolor: '#f8f9fa' }}>New Booking - Room {selected?.roomNumber}</DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <br />
          {isLoading && (
            <div style={overlayStyle}>
              <ClipLoader color="#36d7b7" size={60} />
            </div>
          )}
          <React.Fragment>
            {activeStep === 0 &&
              <Box style={{ padding: 10 }}>
                <Grid className="row" sx={{ mb: 2 }}>
                  {/* Dates */}
                  <Grid className="col-sm-4" >
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Stack spacing={2}>
                          <TextField
                            label="Check-In Date"
                            type="date"
                            value={checkindate}
                            onChange={handleDate1Change}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          />
                          <TextField
                            label="Check-Out Date"
                            type="date"
                            value={checkoutdate}
                            onChange={handleDate2Change}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          />
                          <TextField
                            label="No of Days"
                            value={noofdays}
                            size="small"
                            InputProps={{ readOnly: true }}
                          />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Time */}
                  <Grid className="col-sm-4" item xs={12} md={4}>
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Stack spacing={2}>
                          <TextField
                            label="Check-In Time"
                            value={checkintime}
                            onChange={(e) => setcheckintime(e.target.value)}
                            size="small"
                          />
                          <TextField
                            label="Check-Out Time"
                            value={checkouttime}
                            onChange={(e) => setcheckouttime(e.target.value)}
                            size="small"
                          />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Guests */}
                  <Grid className="col-sm-4" item xs={12} md={4}>
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Stack spacing={2}>
                          {[
                            { label: "Adults", value: adults, set: setadults, min: 1 },
                            { label: "Children", value: childs, set: setchilds, min: 0 },
                          ].map((item) => (
                            <Box key={item.label} display="flex" justifyContent="space-between" alignItems="center">
                              <Typography fontWeight={600}>{item.label}</Typography>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <IconButton
                                  size="small"
                                  onClick={() => item.set(Math.max(item.min, item.value - 1))}
                                >
                                  <Remove />
                                </IconButton>
                                <Typography fontWeight={700}>{item.value}</Typography>
                                <IconButton
                                  size="small"
                                  onClick={() => item.set(item.max ? Math.min(item.max, item.value + 1) : item.value + 1)}
                                >
                                  <Add />
                                </IconButton>
                              </Stack>
                            </Box>
                          ))}

                          <Divider />

                          <Box display="flex" justifyContent="space-between">
                            <Typography fontWeight={600}>Rooms</Typography>
                            <Typography fontWeight={700}>{noofrooms}</Typography>
                          </Box>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Grid className="row" spacing={2}>
                      <Grid className="col-sm-2" md={2}>
                        <TextField
                          select
                          label="Room Type"
                          value={rtypeid}
                          onChange={(e) => handleroomtypeChange(e.target.value)}
                          size="small"
                          fullWidth
                        >
                          {roomTypes.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.roomTypeName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid className="col-sm-1" md={2}>
                        <TextField
                          select
                          label="Room No"
                          value={roomid}
                          onChange={(e) => setroomid(e.target.value)}
                          size="small"
                          fullWidth
                        >
                          {rooms.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.data.roomNo}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid className="col-sm-2" md={2}>
                        <TextField
                          select
                          label="Plan"
                          value={planid}
                          onChange={(e) => handleplanChange(e.target.value)}
                          size="small"
                          fullWidth
                        >
                          {plans.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.data.planName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid className="col-sm-2" md={2}>
                        <TextField
                          label="Amount"
                          value={amount}
                          onChange={handleamount}
                          size="small"
                          fullWidth
                          InputProps={{ readOnly: planid !== "OTA" }}
                        />
                      </Grid>

                      <Grid className="col-sm-2" md={2}>
                        <TextField
                          label="Discount"
                          value={discount}
                          onChange={(e) => caltotal(e.target.value)}
                          size="small"
                          fullWidth
                        />
                      </Grid>

                      <Grid className="col-sm-2" md={2}>
                        <TextField
                          label="Room Rate"
                          value={roomrate}
                          size="small"
                          fullWidth
                        />
                      </Grid>


                      <Grid className="col-sm-1" md={2}>
                        <Button
                          fullWidth
                          variant="contained"
                          sx={{ height: 40, borderRadius: 2 }}
                          onClick={handleRoomArray}
                        >
                          <Add />
                        </Button>
                      </Grid>
                    </Grid>
                    {
                      bookingrooms.map((item, index) =>

                        <Grid key={index} className="row mt-3" spacing={2}>
                          <Grid className="col-sm-2" md={2}>
                            <TextField
                              readOnly disabled defaultValue={item.roomtypename}
                              size="small"
                              fullWidth
                            >
                            </TextField>
                          </Grid>

                          <Grid className="col-sm-1" md={2}>
                            <TextField
                              readOnly defaultValue={item.roomno}
                              size="small"
                              fullWidth disabled
                            >

                            </TextField>
                          </Grid>

                          <Grid className="col-sm-2" md={2}>
                            <TextField
                              readOnly
                              defaultValue={item.planname}
                              size="small" disabled
                              fullWidth
                            >

                            </TextField>


                          </Grid>

                          <Grid className="col-sm-2" md={2}>
                            <TextField
                              readOnly defaultValue={item.amount}
                              size="small"
                              fullWidth disabled
                              InputProps={{ readOnly: planid !== "OTA" }}
                            />
                          </Grid>

                          <Grid className="col-sm-2" md={2}>
                            <TextField
                              defaultValue={item.discount}
                              size="small"
                              fullWidth disabled
                            />
                          </Grid>

                          <Grid className="col-sm-2" md={2}>
                            <TextField
                              defaultValue={item.roomrate}
                              size="small"
                              fullWidth disabled
                            />
                          </Grid>

                          <Grid className="col-sm-1" md={2}>
                            <button
                              className='btn btn-sm btn-danger'
                              fullWidth
                              variant="contained"
                              sx={{ height: 40, borderRadius: 2 }}
                              onClick={() => removeItem(item)}
                            >
                              <Delete />
                            </button>
                          </Grid>
                        </Grid>


                      )
                    }
                  </CardContent>
                </Card>

              </Box>

            }
            {activeStep === 1 &&
              <Box >
                <div className='card'>
                  <div className="card-body">
                    <div className='row'>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={custname} onChange={(e) => setcustname(e.target.value)} label="Customer Name" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={mobile} onChange={handlemobile} label="Mobile" type='tel' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' value={email} onChange={(e) => setemail(e.target.value)} label="Email" type='email' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={address} onChange={(e) => setaddress(e.target.value)} label="Address" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={city} onChange={(e) => setcity(e.target.value)} label="City" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <FormControl className='form-control'>
                          <InputLabel id="state" style={{ backgroundColor: "white" }}>State</InputLabel>
                          <Select labelId='state' size='small' value={state} onChange={(e) => setstate(e.target.value)} label="State">
                            <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                            <MenuItem value="Andhra Pradesh">Andhra Pradesh</MenuItem>
                            <MenuItem value="Arunachal Pradesh">Arunachal Pradesh</MenuItem>
                            <MenuItem value="Assam">Assam</MenuItem>
                            <MenuItem value="Bihar">Bihar</MenuItem>
                            <MenuItem value="Chhattisgarh">Chhattisgarh</MenuItem>
                            <MenuItem value="Goa">Goa</MenuItem>
                            <MenuItem value="Gujarat">Gujarat</MenuItem>
                            <MenuItem value="Haryana">Haryana</MenuItem>
                            <MenuItem value="Himachal Pradesh">Himachal Pradesh</MenuItem>
                            <MenuItem value="Jharkhand">Jharkhand</MenuItem>
                            <MenuItem value="Karnataka">Karnataka</MenuItem>
                            <MenuItem value="Kerala">Kerala</MenuItem>
                            <MenuItem value="Madhya Pradesh">Madhya Pradesh</MenuItem>
                            <MenuItem value="Manipur">Manipur</MenuItem>
                            <MenuItem value="Meghalaya">Meghalaya</MenuItem>
                            <MenuItem value="Mizoram">Mizoram</MenuItem>
                            <MenuItem value="Nagaland">Nagaland</MenuItem>
                            <MenuItem value="Odisha">Odisha</MenuItem>
                            <MenuItem value="Punjab">Punjab</MenuItem>
                            <MenuItem value="Rajasthan">Rajasthan</MenuItem>
                            <MenuItem value="Sikkim">Sikkim</MenuItem>
                            <MenuItem value="Tamil Nadu">Tamil Nadu</MenuItem>
                            <MenuItem value="Telangana">Telangana</MenuItem>
                            <MenuItem value="Tripura">Tripura</MenuItem>
                            <MenuItem value="Uttar Pradesh">Uttar Pradesh</MenuItem>
                            <MenuItem value="Uttarakhand">Uttarakhand</MenuItem>
                            <MenuItem value="West Bengal">West Bengal</MenuItem>
                            <MenuItem value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</MenuItem>
                            <MenuItem value="Chandigarh">Chandigarh</MenuItem>
                            <MenuItem value="Dadra and Nagar Haveli and Daman and Diu">Dadra and Nagar Haveli and Daman and Diu</MenuItem>
                            <MenuItem value="Lakshadweep">Lakshadweep</MenuItem>
                            <MenuItem value="Delhi">Delhi</MenuItem>
                            <MenuItem value="Puducherry">Puducherry</MenuItem>
                            <MenuItem value="Ladakh">Ladakh</MenuItem>
                            <MenuItem value="Jammu and Kashmir">Jammu and Kashmir</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <FormControl className='form-control'>
                          <InputLabel id="gender" style={{ backgroundColor: "white" }}>Gender</InputLabel>
                          <Select labelId='gender' size='small' value={gender} onChange={(e) => setgender(e.target.value)} label="Age">
                            <MenuItem value='Male'>Male</MenuItem>
                            <MenuItem value='Female'>Female</MenuItem>
                            <MenuItem value='Other'>Other</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <FormControl className='form-control'>
                          <TextField className='form-control' color="secondary" value={visitpurpose} onChange={(e) => setvisitpurpose(e.target.value)} label="Visit Purpose" type='text' size='small' />
                        </FormControl>
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <FormControl className='form-control'>
                          <TextField className='form-control' color="secondary" value={companydetails} onChange={(e) => setcompanydetails(e.target.value)} label="Company Details" type='text' size='small' />
                        </FormControl>
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' value={gstname} onChange={(e) => setgstname(e.target.value)} label="GST Name" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' value={gstno} onChange={(e) => setgstno(e.target.value)} label="GST No" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <FormControl className='form-control'>
                          <InputLabel id="bookingsource" style={{ backgroundColor: "white" }}>Booking Source</InputLabel>
                          <Select labelId='bookingsource' size='small' value={bookingsource} onChange={(e) => setbookingsource(e.target.value)} label="Age">
                            {
                              bookingtypes.map((item, index) =>
                                <MenuItem key={index} value={item.data.bookingtype}>{item.data.bookingtype}</MenuItem>
                              )
                            }

                          </Select>
                        </FormControl>
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" label="Booking Date" type='date' value={bookingDate} onChange={(e) => setbookingDate(e.target.value)} size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={documenttype} onChange={(e) => setdocumenttype(e.target.value)} label="Document Type" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                        <TextField className='form-control' color="secondary" value={idno} onChange={(e) => setidno(e.target.value)} label="ID No" type='text' size='small' />
                      </div>
                      <div className='col-sm-3 mt-4'>
                      </div>



                    </div>
                  </div>
                </div>
              </Box>

            }

            {activeStep === 2 &&
              <Box className="row">
                <Grid className='col-sm-3 mt-4'>
                  <Card sx={{ borderRadius: 3 }}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Typography>Visitor Photo</Typography>
                        <Grid item xs={12} md={8}>
                          <Webcam
                            audio={false}
                            ref={webcamRef1}
                            screenshotFormat="image/jpeg"
                            width="100%"
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1 }}
                            onClick={captureVisitor}
                          >
                            Capture
                          </Button>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          {visitorPhoto && (
                            <>
                              <Typography fontWeight={600}>Preview</Typography>
                              <img src={visitorPhoto} alt="Visitor" width="100%" />
                              <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: 1 }}
                                onClick={uploadToFirebase1}
                                disabled={uploadingVisitor}
                                startIcon={
                                  uploadingVisitor ? <CircularProgress size={18} /> : null
                                }
                              >
                                {uploadingVisitor ? "Uploading..." : "Upload"}
                              </Button>

                            </>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid className='col-sm-3 mt-4'>
                  <Card sx={{ borderRadius: 3 }}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Typography>ID Proof Front</Typography>
                        <Grid item xs={12} md={8}>
                          <Webcam
                            audio={false}
                            ref={webcamRef2}
                            screenshotFormat="image/jpeg"
                            width="100%"
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1 }}
                            onClick={captureIdFront}
                          >
                            Capture
                          </Button>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          {idFront && (
                            <>
                              <Typography fontWeight={600}>Preview</Typography>
                              <img src={idFront} alt="ID Front" width="100%" />
                              <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: 1 }}
                                onClick={uploadToFirebase2}
                                disabled={uploadingIdFront}
                                startIcon={uploadingIdFront ? <CircularProgress size={18} /> : null}
                              >
                                {uploadingIdFront ? "Uploading..." : "Upload"}
                              </Button>

                            </>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid className='col-sm-3 mt-4'>
                  <Card sx={{ borderRadius: 3 }}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Typography>ID Proof Back</Typography>
                        <Grid item xs={12} md={8}>
                          <Webcam
                            audio={false}
                            ref={webcamRef3}
                            screenshotFormat="image/jpeg"
                            width="100%"
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1 }}
                            onClick={captureIdBack}
                          >
                            Capture
                          </Button>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          {idBack && (
                            <>
                              <Typography fontWeight={600}>Preview</Typography>
                              <img src={idBack} alt="ID Back" width="100%" />
                              <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: 1 }}
                                onClick={uploadToFirebase3}
                                disabled={uploadingIdBack}
                                startIcon={uploadingIdBack ? <CircularProgress size={18} /> : null}
                              >
                                {uploadingIdBack ? "Uploading..." : "Upload"}
                              </Button>

                            </>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid className='col-sm-3 mt-4'>
                  <Card sx={{ borderRadius: 3 }}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Typography>Couple Photo</Typography>
                        <Grid item xs={12} md={8}>
                          <Webcam
                            audio={false}
                            ref={webcamRef4}
                            screenshotFormat="image/jpeg"
                            width="100%"
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            sx={{ mt: 1 }}
                            onClick={captureCouple}
                          >
                            Capture
                          </Button>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          {couplePhoto && (
                            <>
                              <Typography fontWeight={600}>Preview</Typography>
                              <img src={couplePhoto} alt="Couple" width="100%" />
                              <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: 1 }}
                                onClick={uploadToFirebase4}
                                disabled={uploadingCouple}
                                startIcon={uploadingCouple ? <CircularProgress size={18} /> : null}
                              >
                                {uploadingCouple ? "Uploading..." : "Upload"}
                              </Button>

                            </>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Box>
            }

            {
              activeStep === 3 &&
              <Box >

                <Grid className="row" spacing={2}>

                  {/* CUSTOMER DETAILS */}
                  <Grid className="col-sm-4">
                    <Card sx={{ borderRadius: 3 }}>
                      <CardHeader
                        avatar={
                          <Avatar
                            src={visitorPhoto || ""}
                            sx={{ width: 56, height: 56 }}
                          />
                        }
                        title={custname}
                        subheader={mobile}
                      />
                      <CardContent>
                        <Stack spacing={1}>
                          <Typography variant="body2">{email}</Typography>
                          <Divider />
                          <InfoRow label="Address" value={`${address} ${city} ${state}`} />
                          <InfoRow label="Gender" value={gender} />
                          <InfoRow label="Visit Purpose" value={visitpurpose} />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* GUEST & DOCUMENT INFO */}
                  <Grid className="col-sm-4">
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Stack spacing={1}>
                          <InfoRow label="Adults" value={adults} />
                          <InfoRow label="Children" value={childs} />
                          <Divider />
                          <InfoRow label="GST No" value={gstno || "-"} />
                          <InfoRow label="GST Name" value={gstname || "-"} />
                          <InfoRow label="Document Type" value={documenttype} />
                          <InfoRow label="ID No" value={idno} />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* STAY & BILL SUMMARY */}
                  <Grid className="col-sm-4">
                    <Card sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Stack spacing={1}>
                          <InfoRow label="Check-In" value={checkindate} />
                          <InfoRow label="Check-Out" value={checkoutdate} />
                          <InfoRow label="Days" value={noofdays} />
                          <InfoRow label="Rooms" value={noofrooms} />
                          <Divider />
                          <InfoRow label="Round Off" value={roundoff} />
                          <InfoRow
                            label="Total (Incl. Tax)"
                            value={`₹ ${totalamount}`}
                            highlight
                          />
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>

                </Grid>
                <Card sx={{ mt: 3, borderRadius: 3 }}>
                  <CardContent>
                    <Grid className="row" spacing={2}>

                      {/* PAYMENT MODE 1 */}
                      <Grid className="col-sm-4">
                        <Stack spacing={2}>
                          <TextField
                            select
                            label="Pay Mode 1"
                            size="small"
                            value={paymode1}
                            onChange={(e) => setpaymode1(e.target.value)}
                          >
                            {paymodes.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.data.paymode}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            label="Amount 1"
                            size="small"
                            type="number"
                            value={amount1}
                            onChange={handleamount1}
                          />

                          <TextField
                            label="Payment Note 1"
                            size="small"
                            value={paytime1}
                            onChange={(e) => setpaytime1(e.target.value)}
                          />
                        </Stack>
                      </Grid>

                      {/* PAYMENT MODE 2 */}
                      <Grid className="col-sm-4">
                        <Stack spacing={2}>
                          <TextField
                            select
                            label="Pay Mode 2"
                            size="small"
                            value={paymode2}
                            onChange={(e) => setpaymode2(e.target.value)}
                          >
                            {paymodes.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.data.paymode}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            label="Amount 2"
                            size="small"
                            type="number"
                            value={amount2}
                            onChange={handleamount2}
                          />

                          <TextField
                            label="Payment Note 2"
                            size="small"
                            value={paytime2}
                            onChange={(e) => setpaytime2(e.target.value)}
                          />
                        </Stack>
                      </Grid>

                      {/* TOTALS */}
                      <Grid className="col-sm-4">
                        <Stack spacing={2}>
                          <TextField
                            label="Paid Amount"
                            size="small"
                            value={advance}
                            InputProps={{ readOnly: true }}
                          />
                          <TextField
                            label="Remaining"
                            size="small"
                            value={remaining}
                            InputProps={{ readOnly: true }}
                          />
                          <TextField
                            label="Note"
                            size="small"
                            value={note}
                            onChange={(e) => setnote(e.target.value)}
                          />
                        </Stack>
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>


              </Box>
            }


            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                pt: 4,
                pb: 2,
                px: 1,
                borderTop: '1px solid #f1f5f9',
                mt: 4,
                alignItems: 'center'
              }}
            >
              {/* CANCEL BUTTON: Always visible to let the user exit */}
              <Button
                color="error"
                variant="text"
                onClick={handleClose} // Replace with your close/cancel function
                sx={{
                  fontWeight: 700,
                  px: 3,
                  borderRadius: 3,
                  '&:hover': { bgcolor: '#fff1f2' }
                }}
              >
                Discard
              </Button>

              <Box sx={{ flex: '1 1 auto' }} />

              {/* BACK BUTTON: Styled with an Icon instead of a local PNG */}
              <Button
                variant="outlined"
                disabled={activeStep === 0}
                onClick={handleBack}
                startIcon={<ArrowBackIosNew sx={{ fontSize: '14px !important' }} />}
                sx={{
                  mr: 2,
                  borderRadius: 3,
                  px: 3,
                  fontWeight: 700,
                  border: '1.5px solid #e2e8f0',
                  color: '#64748b',
                  '&:disabled': { border: '1px solid #f1f5f9' }
                }}
              >
                Back
              </Button>

              {/* PRIMARY ACTION: Context-aware styling */}
              {activeStep === steps.length - 1 ? (
                <Button
                  variant="contained"
                  onClick={checkoutReservation}
                  sx={{
                    borderRadius: 3,
                    px: 4,
                    py: 1.2,
                    fontWeight: 800,
                    bgcolor: '#10b981', // Success Green for final confirmation
                    boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.3)',
                    '&:hover': { bgcolor: '#059669', boxShadow: 'none' }
                  }}
                >
                  Confirm & Book Room
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  endIcon={<ArrowForwardIos sx={{ fontSize: '14px !important' }} />}
                  sx={{
                    borderRadius: 3,
                    px: 4,
                    py: 1.2,
                    fontWeight: 800,
                    bgcolor: '#6366f1', // Indigo for progress
                    boxShadow: '0 10px 15px -3px rgba(99, 102, 241, 0.3)',
                    '&:hover': { bgcolor: '#4f46e5', boxShadow: 'none' }
                  }}
                >
                  Continue
                </Button>
              )}
            </Box>
          </React.Fragment >
        </DialogContent>

      </Dialog>


      <div className="modal fade" id="visitorModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Visitor Image</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className='col-sm-8'>
                  <Webcam audio={false} ref={webcamRef1} screenshotFormat="image/jpeg" width="100%" />
                  <button className='btn btn-primary' onClick={captureVisitor}>Capture</button>
                </div>
                <div className="col-sm-4">
                  {visitorPhoto && (
                    <div>
                      <h3>Preview</h3>
                      <img src={visitorPhoto} alt="Captured" width="100%" />
                      <button className='btn btn-info' onClick={uploadToFirebase1}>Upload Image</button>
                    </div>
                  )}
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="idFrontmodal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">ID Proof Front</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className='col-sm-8'>
                  <Webcam audio={false} ref={webcamRef2} screenshotFormat="image/jpeg" width="100%" />
                  <button className='btn btn-primary' onClick={captureIdFront}>Capture</button>
                </div>
                <div className="col-sm-4">
                  {idFront && (
                    <div>
                      <h3>Preview</h3>
                      <img src={idFront} alt="Captured" width="100%" />
                      <button className='btn btn-info' onClick={uploadToFirebase2}>Upload Image</button>
                    </div>
                  )}
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="idBackmodal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Id Proof Back</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className='col-sm-8'>
                  <Webcam audio={false} ref={webcamRef3} screenshotFormat="image/jpeg" width="100%" />
                  <button className='btn btn-primary' onClick={captureIdBack}>Capture</button>
                </div>
                <div className="col-sm-4">
                  {idBack && (
                    <div>
                      <h3>Preview</h3>
                      <img src={idBack} alt="Captured" width="100%" />
                      <button className='btn btn-info' onClick={uploadToFirebase3}>Upload Image</button>
                    </div>
                  )}
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="coupleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Couple Photo</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className='col-sm-8'>
                  <Webcam audio={false} ref={webcamRef4} screenshotFormat="image/jpeg" width="100%" />
                  <button className='btn btn-primary' onClick={captureCouple}>Capture</button>
                </div>
                <div className="col-sm-4">
                  {couplePhoto && (
                    <div>
                      <h3>Preview</h3>
                      <img src={couplePhoto} alt="Captured" width="100%" />
                      <button className='btn btn-info' onClick={uploadToFirebase4}>Upload Image</button>
                    </div>
                  )}
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>

          </div>
        </div>
      </div>



    </Box>
  );
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000, // Ensure the overlay is on top
};
